document.addEventListener("DOMContentLoaded", function () {
	const backToTop = document.getElementById("back-to-top");

	if (!backToTop) return; // Exit if element doesn't exist

	let lastScrollY = window.scrollY;

	window.addEventListener("scroll", function () {
		const currentScrollY = window.scrollY;
		const windowHeight = window.innerHeight;
		const documentHeight = document.documentElement.scrollHeight;

		const atBottom = windowHeight + currentScrollY >= documentHeight - 2; // 2px tolerance

		const scrollingUp = currentScrollY < lastScrollY;

		if (atBottom || (scrollingUp && currentScrollY >= 500)) {
			backToTop.classList.add("visible");
		} else {
			backToTop.classList.remove("visible");
		}

		lastScrollY = currentScrollY;
	});

	backToTop.addEventListener("click", function (event) {
		event.preventDefault();
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	});
});
